import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';

const PaymentMethod = (props) => {
  const { clubMembership } = props;
  return (
    <p className="c7-account__credit-card">
      <strong>Payment method</strong>
      <br />
      <CreditCardDisplay creditCard={clubMembership.customerCreditCard} />
    </p>
  );
};

export default PaymentMethod;
